<section class="conta-certa">
    <ng-template #loading>
        <div class="loaderBox" style="min-height:400px;">
            <div class="loader medium"></div>
        </div>
    </ng-template>
    <div class="close-modal" (click)="dismiss()"><img alt="" src="assets/svg/S-027.svg"/></div>

    <div class="row" *ngIf="contaCertaSimulation$ | async as simulation; else loading">
        <div class="col" *ngIf="!simulation.success">
            <div class="row">
                <div class="col d-flex flex-column text-center">
                    <span class="d-block">
                        <i class="icon icon-4x icon-edponline-Bra-006"  aria-hidden="true"></i>
                    </span>
                    
                    <h3>{{ 'pt.edponline.conta-certa-modal.title' | translate }}</h3>
                    <p class="disclaimer error-msg"><i class="fa fa-exclamation-circle fa-lg m-3"  aria-hidden="true"></i> {{ 'pt.edponline.conta-certa-modal.error' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="col" *ngIf="simulation.success">
            <div class="row">
                <div class="col d-flex flex-column text-center">
                    <span class="d-block">
                        <i class="icon icon-4x icon-edponline-Bra-006"  aria-hidden="true"></i>
                    </span>

                    <h3 class="mb-4">{{ 'pt.edponline.conta-certa-modal.title' | translate }}</h3>
                    <p class="disclaimer text-left">{{ 'pt.edponline.conta-certa-modal.disclaimer' | translate }}</p>
                </div>
            </div>
            <div class="row form-row">
                <div class="item ">
                    <p>{{ 'pt.edponline.conta-certa-modal.fixed-value0' | translate }}</p>
                    <div class="cell">
                        <form [formGroup]="form">
                            <input 
                                type="number"
                                class="form-control"
                                placeholder="valor fixo"
                                formControlName="value"
                                (ngModelChange)="changed()" >
                            <span>{{ 'pt.edponline.conta-certa-modal.month-value' | translate }}</span>
                            <span class="sum-symbol plus"></span>
                        </form>
                    </div>
                </div>
                <div class="item">
                    <p>{{ 'pt.edponline.conta-certa-modal.fixed-value' | translate }}</p>
                    <div class="cell">
                        <span class="value">{{form.value.value | number:'1.2-2' : 'pt'}}</span>
                        <span>{{ 'pt.edponline.conta-certa-modal.month-value' | translate }}</span>
                        <span class="sum-symbol plus"></span>
                    </div>
                </div>
                <div class="item">
                    <p>{{ 'pt.edponline.conta-certa-modal.pack-edp' | translate }}</p>
                    <div class="cell">
                        <span>{{data.pack.discount | number:'1.2-2' : 'pt'}}{{ 'pt.edponline.conta-certa-modal.month-value' | translate }}</span>
                        <span class="sum-symbol equal"></span>
                    </div>
                </div>
                <div class="item">
                    <p>{{ 'pt.edponline.conta-certa-modal.month-total' | translate }}</p>
                    <div class="cell">
                        <span>{{sum | number:'1.2-2' : 'pt'}}{{ 'pt.edponline.conta-certa-modal.month-value' | translate }}</span>
                    </div>
                </div>
            </div>
            <div class="row error-block">
                <div class="col">
                 <span class="action tiny-text mb-2 mt-2 d-block" *ngIf="form.controls.value.hasError('required') && isSubmited">
                    {{ 'pt.edponline.conta-certa-modal.required-field' | translate }}
                </span>
                <span class="action tiny-text mb-2 mt-2 d-block" *ngIf="(form.controls.value.hasError('min') || form.controls.value.hasError('max')) && isSubmited">
                    {{ 'pt.edponline.conta-certa-modal.value-between' | translate }} {{simulation.minimum}}{{ 'pt.edponline.conta-certa-modal.value-between2' | translate }} {{simulation.maximum}}{{ 'pt.edponline.conta-certa-modal.value-between3' | translate }}
                </span> 
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="tiny-text mb-4 secondary-disclaimer">{{ 'pt.edponline.conta-certa-modal.disclaimer2' | translate }}</p>
                </div>
            </div>
            <div class="row" >
                <div class="col text-right">
                    <button 
                    class="btn btn-primary" 
                    *ngIf="data.discount.checkCondition('hasDirectDebit')" 
                    (click)="close()"
                    >
                        <span class="d-inline-block align-middle mr-2">
                            <i class="icon icon-edponline-Bop-074 tiny-text" aria-hidden="true"></i>
                        </span>
                        {{ 'pt.edponline.conta-certa-modal.add' | translate }}
                    </button>
                </div>
            </div> 
            <div class="row" *ngIf="!data.discount.checkCondition('hasDirectDebit')">
                <div class="col">
                    <p class="tiny-text" >
                        <span class="info">
                            <i class="fa fa-exclamation-circle icon-size" aria-hidden="true"></i>
                        </span>
                        <span class="disclaimer-w-icon" [innerHTML]="'pt.edponline.conta-certa-modal.disclaimer3' | translate"></span>  
                    </p>
                </div>
            </div> 
        </div>
    </div>
</section>